import CompareOptionsScreen from 'features/moveMoney/screens/compareOption/CompareOption';
import React from 'react';

export default function CompareOptionPage() {
  return <CompareOptionsScreen />;
}
